import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { ProductsDropdownProps, ProductsDropdownRespSuccess } from '../types';
import { useQueryParams } from '@hooks/queryParams';
import { useAppContext } from '@contexts/app';

export const useAdditiveDropdown = ({ externalSiteId }: ProductsDropdownProps) => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const { parseParams } = useQueryParams();

  const queryParams = parseParams({ externalSiteId });

  const { data, error, isFetching } = useQuery<ProductsDropdownRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.additive, externalSiteId],
    queryFn: () => queryFetch({ url: `dropdowns/concrete_direct_additive${queryParams}` }),
    placeholderData: (previousData) => previousData as ProductsDropdownRespSuccess,
    enabled: enabled && Boolean(externalSiteId),
  });

  return {
    data,
    error,
    isLoading: isFetching,
  };
};
